/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Promote_MainInputs */

const cs_property_ai_promote_main = /** @type {(inputs: Property_Ai_Promote_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat jako hlavní fotku`)
};

const en_property_ai_promote_main = /** @type {(inputs: Property_Ai_Promote_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add as main photo`)
};

/**
* | output |
* | --- |
* | "Add as main photo" |
*
* @param {Property_Ai_Promote_MainInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_promote_main = /** @type {((inputs?: Property_Ai_Promote_MainInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Promote_MainInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_promote_main(inputs)
	return cs_property_ai_promote_main(inputs)
});